import _ from 'lodash';
import React from 'react';
import { Avatar } from 'src/@vymo/ui/atoms';
import { List } from 'src/@vymo/ui/blocks';
import { useAppDispatch } from 'src/store/hooks';
import { getItemAttributesValues, getModuleNameFromCode } from '../queries';
import { handleSearchNavigation } from './queries';
import { SearchDetailsProps } from './types';
import styles from './index.module.scss';

function SearchDetails({ items, type }: SearchDetailsProps) {
  const dispatch = useAppDispatch();
  const getHighlightValueFromString = (
    highlightValue,
    indexInArray,
    highlightField,
  ) => {
    if (highlightValue.indexOf('<highlight>') < 0) {
      if (
        highlightValue.length > 20 &&
        indexInArray === 0 &&
        highlightField !== 'name'
      ) {
        return `...${highlightValue.substring(
          highlightValue.length - 20,
          highlightValue.length,
        )}`;
      }

      if (
        highlightValue.length > 20 &&
        indexInArray > 0 &&
        highlightField !== 'name'
      ) {
        return `${highlightValue.substring(0, 20)}...`;
      }

      return highlightValue;
    }

    const actualHighlight = highlightValue.substring(
      highlightValue.lastIndexOf('<highlight>') + 11,
      highlightValue.lastIndexOf('</highlight>'),
    );

    return (
      <span className={styles.navbar__result__item__highlight}>
        {actualHighlight}
      </span>
    );
  };

  const getHighlightedDiv = (highlightObject, isNameFieldCondiv, leadName) => {
    const allHighlightFields = Object.keys(highlightObject) || [];

    for (let j = 0; j < allHighlightFields.length; j++) {
      const highlightField = allHighlightFields[j];
      if (highlightField) {
        const highlightValuesArray = highlightObject[highlightField] || [];

        for (let i = 0; i < highlightValuesArray.length; i++) {
          const highlightValue = highlightValuesArray[i];
          const allHighlights = highlightValue.split(/(<.*?>.*?<\/.*?>)/g);

          const highlightMarkups = allHighlights.map((eachHighlight, index) =>
            getHighlightValueFromString(eachHighlight, index, highlightField),
          );

          if (highlightField === 'name' && isNameFieldCondiv) {
            return <span>{highlightMarkups}</span>;
          }

          if (
            highlightField !== 'name' &&
            !isNameFieldCondiv &&
            !allHighlightFields.includes('name')
          ) {
            return <span>{highlightMarkups}</span>;
          }
        }
      }
    }

    return leadName;
  };

  return (
    <List
      onItemClick={(idx) => handleSearchNavigation(items[idx], type, dispatch)}
      className={styles.search__result}
    >
      {items.map((item) => (
        <List.Item key={item.code} className={styles.search__result__item}>
          <Avatar
            size="small"
            background="var(--background-default)"
            text={_.capitalize(item.name?.charAt(0))}
          />

          <div>
            <div>
              <div className={styles.search__result__item__title}>
                {getHighlightedDiv(item.highlight, true, item.name)}
              </div>

              {getHighlightedDiv(item.highlight, false, '') && (
                <div className={styles.search__result__item__description}>
                  {getHighlightedDiv(item.highlight, false, '')}
                </div>
              )}

              {_.map(getItemAttributesValues(item), (v) => (
                <div
                  className={styles.search__result__item__description}
                  key={v}
                >
                  {v}
                </div>
              ))}
            </div>
            <div className={styles.search__result__item__description}>
              in
              <span> {getModuleNameFromCode(item.module_code)}</span>
            </div>
          </div>
        </List.Item>
      ))}
    </List>
  );
}

export default SearchDetails;
